<template>
  <header class="component-header">
    <h1 class="app-logo">
      <router-link :to="{name: RouterConst.HOME}"><img :src="Const.LOGO_PATH" alt="{{ Config.APP_NAME }}"/></router-link>
    </h1>
    <ul class="menu" v-if="authStore.isAuth">
      <li class="item">
        <div v-on:click="menuStore.switchPanel()">
          <template v-if="menuStore.menuPanelVisible">
            <i class="fa-solid fa-x"></i>
            <span>閉じる</span>
          </template>
          <template v-if="!menuStore.menuPanelVisible">
            <i class="fa-solid fa-ellipsis"></i>
            <span>メニュー</span>
          </template>
        </div>
      </li>
    </ul>
  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Config from '@/const/Config'
import { useMenuStore } from '@/store/menu'
import { useAuthStore } from '@/store/auth'
import { RouterConst } from '@/const/Router'
import Const from '@/const/Shinsei/Option';

export default defineComponent({
  setup() {
    const menuStore = useMenuStore()
    const authStore = useAuthStore()

    return {
      menuStore,
      authStore,
      Config,
      RouterConst,
      Const,
    }
  },
})
</script>

<style lang="scss" scoped>
@import '@scss/components/header.scss';
</style>
